export default class UserAdminController {
  constructor($rootScope, $state, AdministrationService, UIService) {
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.Administration = AdministrationService;
    this.UI = UIService;

    $rootScope.$on('$receivedServerStatus', (evt, data) => {
      this.status = data;
    });

    this.type = 'password';
    this.iconType = 'mdi-lock';
    this.user = {
      imap: false,
      email: '',
      name: '',
      password: ''
    };
    this.sendEmail = true;
    this.loaded = true;
  }

  // If we toggled imap to true, don't need to explicitely send confirmation email to complete registration
  // TODO - Send email with confirmation of registration instead of completing registration
  toggleImap = () => {
    // Reversed logic
    this.sendEmail = (this.user.imap !== false);
  };

  randomizePassword = () => {
    let chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
    let pass = "";
    let size = Math.floor(Math.random() * (16 - 8 + 1)) + 8;
    for (let x = 0; x < size; x++) {
      let i = Math.floor(Math.random() * chars.length);
      pass += chars.charAt(i);
    }
    this.user.password = pass;
  };

  showPassword = () => {
    if (this.type.includes('password')) {
      this.type = 'text';
      this.iconType = 'mdi-lock-open';
    } else {
      this.type = 'password';
      this.iconType = 'mdi-lock';
    }
  };

  createAccount = () => {
    this.loaded = false;
    if (this.user.imap) {
      this.randomizePassword();
    }
    this.Administration.createUser(this.user).then((newUser) => {
      if (this.sendEmail) {
        this.Administration.sendUserCreationEmail(newUser.id).then(() => {
          this.UI.addToast('Utilizador adicionado');
          this.$state.go('app.administration.main');
        }).catch(err => {
          console.log(err);
          this.UI.addToast('Utilizador adicionado');
          this.UI.addToast('Não foi possível enviar email');
          this.$state.go('app.administration.main');
        });
      } else {
        this.UI.addToast('Utilizador adicionado');
        this.$state.go('app.administration.main');
      }
    });
  }
}

UserAdminController.$inject = ['$rootScope', '$state', 'AdministrationService', 'UIService'];
